import { render, staticRenderFns } from "./upgradeUPG.vue?vue&type=template&id=4e9590a9&scoped=true&"
import script from "./upgradeUPG.vue?vue&type=script&lang=js&"
export * from "./upgradeUPG.vue?vue&type=script&lang=js&"
import style0 from "./upgradeUPG.vue?vue&type=style&index=0&id=4e9590a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9590a9",
  null
  
)

export default component.exports